t<template>
  <div class="calculator-wrapper">
    <div class="calculator">
      <CalculatorHeading :step="step"></CalculatorHeading>
      <h2>{{ $t('wiring.question') }}</h2>

      <img
        class="count-image shadow"
        :src="require('@/assets/installation.svg')"
      />

      <div style="display: flex; flex-direction: row; align-items: center;">
        <div style="padding-right: 5px">{{ $t('wiring.in') }}</div>
        <CountInput
          :counter.sync="wiring"
        ></CountInput>
        <div style="padding-left: 5px">{{ $t('wiring.months') }}.</div>
      </div>

      <div style="padding-top: 20px" class="skip" @click="skip">
        {{ $t('wiring.skipLink') }}
      </div>

      <one-button
        type="primary"
        class="next-btn"
        :class="{ disabled: wiring === null }"
        @click.native="next()"
      >
        {{ $t('next') }}
      </one-button>
      <a @click="$router.push(getPrevStepUrl(step))" class="back-btn">{{ $t('back') }}</a>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import CountInput from "../../components/CountInput";
import CalculatorHeading from "../../components/CalculatorHeading";
import { getStepIndex, redirectToUnselectedStepIfAny, getPrevStepUrl, getNextStepUrl } from "@/utils/steps.js";

export default {
  name: "TimeOfWiring",
  components: { CalculatorHeading, CountInput },
  data() {
    return {
      step: getStepIndex("wiring"),
      getPrevStepUrl: getPrevStepUrl,
      wiring: this.$store.state.data.wiring,
    };
  },
  watch: {
    wiring: function() {
      this.updateWiring(this.wiring);
    }
  },
  mounted() {
    redirectToUnselectedStepIfAny(
      this.step,
      this.$store.state.data,
      this.$router,
      this.$i18n.locale
    );
  },
  methods: {
    ...mapMutations(["updateWiring"]),
    skip() {
      this.wiring = null;
      this.next();
    },
    next() {
      setTimeout(() => this.$router.push(getNextStepUrl(this.step, this.$i18n.locale)), 200);
    }
  }
};
</script>

<style scoped>
.calculator {
  align-items: center;
}
.disabled {
  pointer-events: none;
}

.skip {
  color: #008c96;
  text-decoration: underline;
}
.skip:hover {
  cursor: pointer;
}
</style>
